var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-system page-info"},[_c('heading',{attrs:{"title":"System Status","tag":"site-status-title"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.phpinfo)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }